import { createPluriannualMapper } from "./pluriannualMapperFactory";

export default createPluriannualMapper("NRJ");
